import styles from './Skeleton.module.css';

export type SkeletonProps = {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  count?: number;
  className?: string;
};

function toCss(v: string | number | undefined): string | undefined {
  if (v === undefined) return undefined;
  return typeof v === 'number' ? `${v}px` : v;
}

/**
 * Bloco de skeleton (shimmer) pro loading inicial de listas.
 * Respeita prefers-reduced-motion (sem animacao). Use Spinner pra acoes pontuais.
 */
export function Skeleton({ width, height, radius, count = 1, className }: SkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          data-skeleton
          className={`${styles.skeleton}${className ? ` ${className}` : ''}`}
          style={{
            width: toCss(width),
            height: toCss(height),
            borderRadius: toCss(radius),
          }}
        />
      ))}
    </>
  );
}
